import React from "react";
import PanelEmpresaComponent from "../components/PanelEmpresa/PanelEmpresa";

const PanelEmpresa = (props) => {
  return <PanelEmpresaComponent {...props} />;
};

export default PanelEmpresa;
